import PinchMeAPI from "../lib/PinchMeAPI";
import {
  fetchRecentSamplesPending,
  fetchRecentSamplesSuccess,
  fetchRecentSamplesFail
} from "../dux/recent_samples";

export default function fetchRecentSamples() {
  return dispatch => {
    dispatch(fetchRecentSamplesPending());
    PinchMeAPI.getRecentSamples()
      .then(res => {
        if (res.error) {
          throw res.error;
        }
        dispatch(fetchRecentSamplesSuccess(res));
        return res;
      })
      .catch(error => {
        dispatch(fetchRecentSamplesFail(error));
      });
  };
}
